export const STAGES = [
  { key: 'consultation', label: 'Консультация',    icon: '', color: '#6b7280' },
  { key: 'documents',    label: 'Сбор документов', icon: '', color: '#2563eb' },
  { key: 'mfc',          label: 'Подача в МФЦ',    icon: '', color: '#1d4ed8' },
  { key: 'procedure',    label: 'Процедура',        icon: '', color: '#b45309' },
  { key: 'ip_close',     label: 'Окончание ИП',     icon: '', color: '#d97706' },
  { key: 'completed',    label: 'Завершено',         icon: '', color: '#16a34a' },
  { key: 'refused',      label: 'Отказ',             icon: '', color: '#dc2626' },
];
export const STAGE_MAP = Object.fromEntries(STAGES.map(s => [s.key, s]));
export const STAGES_COURT = [
  { key: 'consultation',   label: 'Консультация',          icon: '', color: '#6b7280' },
  { key: 'documents',      label: 'Сбор документов',       icon: '', color: '#2563eb' },
  { key: 'arbitrage',      label: 'Подача в арбитраж',     icon: '', color: '#1d4ed8' },
  { key: 'procedure',      label: 'Процедура',              icon: '', color: '#b45309' },
  { key: 'procedure_end',  label: 'Завершение процедуры',  icon: '', color: '#d97706' },
  { key: 'completed',      label: 'Завершено',              icon: '', color: '#16a34a' },
  { key: 'refused',        label: 'Отказ',                  icon: '', color: '#dc2626' },
];
export const STAGE_MAP_COURT = Object.fromEntries(STAGES_COURT.map(s => [s.key, s]));

export const DOC_TYPES = [
  { key: 'passport', label: 'Паспорт' },
  { key: 'bki_report', label: 'Отчёт БКИ' },
  { key: 'fssp_report', label: 'Справка ФССП' },
  { key: '2ndfl', label: '2-НДФЛ' },
  { key: 'other', label: 'Прочее' },
];
export function formatMoney(n) {
  if (n === null || n === undefined) return '\u2014';
  return Number(n).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20BD';
}
export function formatDate(d) {
  if (!d) return '\u2014';
  return new Date(d).toLocaleDateString('ru-RU');
}
export function isOverdue(dateStr) {
  if (!dateStr) return false;
  const today = new Date(); today.setHours(0,0,0,0);
  return new Date(dateStr) < today;
}
export function isToday(dateStr) {
  if (!dateStr) return false;
  return dateStr.split('T')[0] === new Date().toISOString().split('T')[0];
}
